import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-item-slider-about',
  templateUrl: './item-slider-about.component.html',
  styleUrls: ['./item-slider-about.component.scss']
})
export class ItemSliderAboutComponent {
  @Input() data: any;

  constructor() {
  }
}
